import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { AvatarIcon } from "../../../../../../patterns/return-to-product-modal/src/avatar-facepile";

export interface JFind1504AvatarFacepileProps {
    icons: string[];
    max: number;
    overlap?: number;
    iconSize?: number;
    totalUserCount: number;
}

export const JFind1504AvatarFacepile = ({
    icons,
    max,
    overlap = 4,
    iconSize = 16,
    totalUserCount
}: JFind1504AvatarFacepileProps) => {
    const userCountPillStyles = css({
        alignItems: "center",
        borderRadius: "66px",
        // eslint-disable-next-line local/ensure-wac-token-usage
        border: "0.67px solid #0B122824",
        color: wacToken("color.neutral.light800"),
        display: "inline-flex",
        fontSize: "9.33px",
        fontWeight: 400,
        gap: token("space.0"),
        height: `${iconSize}px`,
        justifyContent: "center",
        lineHeight: `${iconSize}px`,
        marginInlineStart: `${overlap * -1}px`,
        padding: `${token("space.0")} ${token("space.075")} ${token(
            "space.0"
        )} ${token("space.075")}`,
        textAlign: "center",
        verticalAlign: "middle",
        width: "auto"
    });
    const intl = useIntl();

    const maxUsersStyles = css({
        color: wacToken("color.neutral.light800"),
        fontSize: "12px",
        fontWeight: 400,
        marginInlineStart: 6,
        display: "flex",
        alignItems: "center"
    });

    const andMoreText = intl.formatMessage({
        id: "avatarFacePile.andMoreText",
        defaultMessage: "and more"
    });

    const facepileStyles = [
        css({
            display: "inline-flex",
            height: `${iconSize}px`,
            width: "100%",
            // For some reason negative margin was not working dynamically on the child itself
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            div: {
                marginInlineStart: `-${overlap}px`
            }
        }),
        overlap > 0 &&
            css({
                marginInlineStart: `${overlap}px`
            })
    ];

    return (
        <div css={facepileStyles}>
            {icons.slice(0, max).map((icon, index) => (
                <AvatarIcon
                    key={index}
                    icon={icon}
                    iconSize={iconSize}
                    overlap={overlap}
                />
            ))}
            {totalUserCount > 99 ? (
                <span css={maxUsersStyles}>{andMoreText}</span>
            ) : (
                totalUserCount > max && (
                    <span css={userCountPillStyles}>
                        +{totalUserCount - max}
                    </span>
                )
            )}
        </div>
    );
};
